import { AxiosResponse } from 'axios';
import { FormEntity } from 'src/shared/types/Common';
import { DocumentData } from 'src/shared/types/Document';
import { USER_TYPE_NAMES } from './constants/common';

export const getFileExtension = (fileName: string) => {
  return fileName.substring(fileName.lastIndexOf('.') + 1).toLowerCase();
};

export const isStringValidJson = (str: string) => {
  try {
    JSON.parse(str);
    return true;
  } catch (e) {
    return false;
  }
};

export const paginatorDropdownOptions = [10, 25, 50, 100].map((value) => ({ label: `${value} rows`, value }));

export const generateGuid = () => {
  const guidTemplate = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx';
  return guidTemplate.replace(/[xy]/g, (symbol) => {
    const randomValue = (window.Math.random() * 16) | 0;
    const value = symbol === 'x' ? randomValue : (randomValue & 0x3) | 0x8;
    return value.toString(16);
  });
};

export const getAxiosErrorMessage = (response: AxiosResponse) => {
  if (response?.data) {
    if (typeof response.data === 'string') {
      return response.data;
    } else if (response.data?.errors) {
      return response.data.errors[''][0];
    }
    return response.data[''] && response.data[''][0];
  }
  return 'Something went wrong!';
};

export const mapUserTypesToNames = (userTypes: string[]) => {
  return userTypes
    .map((userType) => USER_TYPE_NAMES[userType])
    .reduce<string[]>((memo, userTypeName) => {
      if (memo.includes(userTypeName)) {
        return memo;
      }

      return [...memo, userTypeName];
    }, []);
};

const filterHashKey = (entity: FormEntity) => {
  if (entity.hasOwnProperty('$$hashKey')) {
    delete entity.$$hashKey;
  }
  for (const key in entity) {
    if (entity.hasOwnProperty(key)) {
      const element = entity[key];
      if (element && typeof element === 'object') {
        filterHashKey(element);
      }
    }
  }
  return entity;
};

const copyEntity = (entity: FormEntity) => {
  const newEntity = JSON.parse(JSON.stringify(entity));
  return filterHashKey(newEntity);
};

export const getFormDataForDoc = (doc: DocumentData) => {
  const formData = new FormData();

  const formEntity: FormEntity = {
    docName: doc.docName,
    docTypeId: doc.docTypeId.toString(),
    userTypes: doc.userTypes,
    roles: doc.roles,
  };

  const conditionalFields = ['caseId', 'docId', 'fields', 'beneId', 'companyId', 'clientCaseIds', 'immigration'];
  conditionalFields.forEach((field) => {
    if (doc[field]) {
      formEntity[field] = doc[field];
    }
  });

  formData.append('document', JSON.stringify(copyEntity(formEntity)));
  formData.append('numberOfFiles', doc.files.length.toString());
  doc.files.forEach((file, idx) => {
    formData.append(`files_${idx}`, file);
  });

  return formData;
};
